/* eslint-disable no-param-reassign */
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_URL

const emptyTw = () => ({
   indeks: '0,00',
   grade: '-',
   responden: 0,
})

const emptySkm = () => ({
   tw1: emptyTw(),
   tw2: emptyTw(),
   tw3: emptyTw(),
   tw4: emptyTw(),
})

const normalizeTw = tw => ({
   indeks: String((tw || {}).indeks ?? '0,00'),
   grade: String((tw || {}).grade ?? '-'),
   responden: Number((tw || {}).responden ?? 0),
})

const normalizeSkm = skm => {
   const source = skm || {}
   return {
      tw1: normalizeTw(source.tw1),
      tw2: normalizeTw(source.tw2),
      tw3: normalizeTw(source.tw3),
      tw4: normalizeTw(source.tw4),
   }
}

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      statistik: {
         skm: emptySkm(),
         skmMpp: emptySkm(),
      },
      perInstansiChart: {
         data: [],
      },
      instansiTriwulan: {
         data: [],
      },
      demografi: {
         jk: { l: 0, p: 0 },
         usia: {},
         pendidikan: {},
         pekerjaan: {},
      },
      unsurPelayanan: {
         data: {},
      },
      saran: {
         data: [],
      },
   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         commit('SET_TAHUN', selectedYear)
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/skm/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_STATISTIK', data.data || data || {})

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getPerInstansiChart({ commit, rootState, state }, { tahun = state.tahun, tw = 1 } = {}) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/skm/chart`, {
            params: { year: selectedYear, tw },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_PER_INSTANSI_CHART', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getInstansiTriwulan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/skm/instansi-triwulan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_INSTANSI_TRIWULAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getDemografi({ commit, rootState, state }, { tahun = state.tahun, tw = 1 } = {}) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/skm/demografi-reponden`, {
            params: { year: selectedYear, tw },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_DEMOGRAFI', data.data || {})

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getUnsurPelayanan({
         commit, rootState, state,
      }, { tahun = state.tahun, instansi = 'DPMPTSP', tw = 1 } = {}) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/skm/unsur-pelayanan`, {
            params: { year: selectedYear, instansi, tw },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_UNSUR_PELAYANAN', (data.data || {}))

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getSaran({ commit, rootState, state }, { tahun = state.tahun, instansi = 'DPMPTSP' } = {}) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/skm/saran`, {
            params: { year: selectedYear, instansi },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_SARAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
   },
   mutations: {
      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         state.statistik = {
            skm: normalizeSkm(data.skm),
            skmMpp: normalizeSkm(data.skmMpp),
         }
      },
      SET_PER_INSTANSI_CHART(state, data) {
         state.perInstansiChart = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_INSTANSI_TRIWULAN(state, data) {
         state.instansiTriwulan = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_DEMOGRAFI(state, data) {
         const source = data || {}

         state.demografi = {
            jk: {
               l: Number((source.jk || {}).l ?? 0),
               p: Number((source.jk || {}).p ?? 0),
            },
            usia: source.usia || {},
            pendidikan: source.pendidikan || {},
            pekerjaan: source.pekerjaan || {},
         }
      },
      SET_UNSUR_PELAYANAN(state, data) {
         state.unsurPelayanan = {
            data: data || {},
         }
      },
      SET_SARAN(state, data) {
         state.saran = {
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
   },
}
